import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type DuplicateActionItemMutationVariables = Types.Exact<{
  data: Types.DuplicateActionItemInput;
}>;


export type DuplicateActionItemMutation = { duplicateActionItem?: { success?: boolean | null, actionItem?: { id: string, identifier?: string | null, title: string } | null } | null };


export const DuplicateActionItemDocument = /*#__PURE__*/ gql`
    mutation DuplicateActionItem($data: DuplicateActionItemInput!) {
  duplicateActionItem(data: $data) {
    success
    actionItem {
      id
      identifier
      title
    }
  }
}
    `;

export function useDuplicateActionItemMutation() {
  return Urql.useMutation<DuplicateActionItemMutation, DuplicateActionItemMutationVariables>(DuplicateActionItemDocument);
};